// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__HcfI0","rootSuccess":"CompleteLink_rootSuccess__2zk24","rootFailure":"CompleteLink_rootFailure__1k0tW","isDisabled":"CompleteLink_isDisabled__kvbSn"};